import { t } from "../services/utils";
const achievementTypes = {
  GOAL_UNLOCKED: 1,
  PERFECT_WEEK: 2,
  PERFECT_MONTH: 3,
  PERFECT_QUARTER: 4,
  PERFECT_HALF_YEAR: 5,
  PERFECT_YEAR: 6,
  LOGGED_25X_WORKOUTS: 7,
  LOGGED_1ST_WORKOUT: 8,
  PR: 9
};
export default achievementTypes;